import i18n from 'i18next';

/**
 * `TFunction` — wlasny, wezszy niz ten z i18next.
 *
 * DLACZEGO NIE BIERZEMY TEGO Z `i18next`
 * --------------------------------------
 * i18next 17 deklaruje tlumaczenie tak (node_modules/i18next/index.d.ts):
 *
 *     type TFunctionResult = string | object | Array<string | object> | undefined | null;
 *     interface TFunction {
 *       <TResult extends TFunctionResult = string, ...>(key, options?): TResult;
 *     }
 *
 * Typ wyniku jest PARAMETREM dobieranym z kontekstu wywolania. W JSX
 * kontekstem jest `ReactNode`. Dopoki typy Reacta 16 trzymaly w `ReactNode`
 * takze `{}`, pasowalo cokolwiek. Typy Reacta 18 `{}` usunely, wiec
 * TypeScript siega po samo ograniczenie — `TFunctionResult`, a w nim siedzi
 * `object`. Efekt: blad przy KAZDYM `{t("cos")}` w kodzie. Bylo ich 1318.
 *
 * DLACZEGO WOLNO ZAWEZIC
 * ----------------------
 * `t()` zwraca co innego niz napis tylko przy opcji `returnObjects`.
 * W calym `src` nie ma ani jednego jej uzycia (sprawdzone), wiec
 * w tym projekcie tlumaczenie ZAWSZE daje napis. Ten typ mowi to wprost.
 *
 * Gdyby kiedys `returnObjects` bylo potrzebne, tu jest miejsce na drugie
 * przeciazenie — a nie na odkrecanie tego z powrotem.
 *
 * STAN NA DZIS: TEN PLIK MOZNA USUNAC
 * -----------------------------------
 * Powyzsze opisuje i18next 17. Projekt stoi juz na 25, a od wersji 21 `t()`
 * zwraca `string` natywnie — wiec powod, dla ktorego ten plik powstal,
 * zniknal u zrodla. Zostaje swiadomie: skasowanie oznacza dotkniecie 86 plikow
 * tylko po to, zeby wrocic do importu z `i18next`, a ten typ jest wezszy
 * i opisany.
 *
 * Kto bedzie i tak w tych plikach grzebal — niech przy okazji zamieni
 * `import { TFunction } from ".../utils/tlumacz"` na `from "i18next"`
 * i skasuje ten plik. `tekst()` nizej zostaje niezaleznie, bo rozwiazuje
 * inna sprawe: wygodne tlumaczenie poza komponentem.
 *
 * To jest typ i nic wiecej: do przegladarki nie trafia z tego pliku
 * ani jeden znak.
 */
export type TFunction = (klucz: string | string[], opcje?: any) => string;

/**
 * Tlumaczenie POZA komponentem — w sagach i tam, gdzie `t` nie przychodzi
 * z propsow.
 *
 * Robi to samo co `i18n.t`, tylko deklaruje napis (uzasadnienie wyzej).
 *
 * NIE WOLNO tego zapisac jako `i18n.t.bind(i18n)`: i18next podstawia
 * wlasciwe `t` dopiero w `init()`, wiec zwiazanie przy imporcie zapamietaloby
 * funkcje sprzed inicjalizacji. Dlatego siegamy po `i18n.t` przy kazdym
 * wywolaniu.
 */
export const tekst: TFunction = (klucz, opcje) => i18n.t(klucz as any, opcje as any) as string;
